<template>
  <div class="modal-backdrop">
    <div class="card col-lg-5 col-md-8 mt-md-4 col-11 p-0 mx-auto">
      <div class="modal-content border-0 p-2">
        <div class="modal-header modalhead">
          <div class="d-flex">
            <div class="">
              <img v-if="!sharevideo.currentUserProfilepic" src="../assets/Group2.svg" class=" currentuserpropic rounded-circle " alt="profilepic">
              <img v-else :src="sharevideo.currentUserProfilepic" class=" currentuserpropic rounded-circle " alt="profilepic">
            </div>
            <div class="d-flex flex-column pl-2 mt-1">
              <span class="black80 fontsize16 proximanova-semibold text-capitalize">{{sharevideo.currentUserFirstname}} {{sharevideo.currentUserLastname}}</span>
              <span class="black80 fontsize12 proximanova text-capitalize">{{sharevideo.currentUserDesignation}}</span>
            </div>
          </div>
          <button type="button" class="close" @click="close('NOTSUCCESS')">&times;</button>
        </div>
        <div class="modal-body bodymodal11">
          <div class="input-group mt-2">
            <input
              type="text"
              name="First Name"
              data-vv-as="First Name"
              data-vv-scope="addBasicinfo"
              class="input-create proximanova"
              v-model.trim="Description"
              autocomplete="nope"
              maxlength="150"
              required
            />
            <span class="bar"></span>
            <label class="label-create proximanova">Write anything about post here</label>
          </div>
          <div class="pt-lg-4 pt-3 privacy">
            <div class="d-flex">
              <span class="black80 fontsize12 proximanova text-capitalize">Share to my Time Line</span>
              <select name="privacy" id="privacy" class="privacy black80 fontsize12 proximanova-semibold p-1 ml-2" v-model="privacy">
                <option value="PUBLIC">Public</option>
                <option value="PRIVATE">Only to me</option>
                <option value="FOLLOWER">Only to my follower</option>
              </select>
            </div>
          </div>
          <div class="sharedcontent mt-4 mb-2">
              <div class="d-flex p-3">
                <div v-if="!sharevideo.videoUserProfilePic" id="profImage" class="text-center pointer rounded-circle white" :class="sharevideo.videoUserFirstName.charAt(0)" oncontextmenu="return false;">
                  <span class="white fontsize16 defpaddingtop text-uppercase">{{sharevideo.videoUserFirstName.charAt(0)}}</span>
                </div>
                <div v-if="sharevideo.videoUserProfilePic">
                  <img :src="sharevideo.videoUserProfilePic" class="videoownerpropic rounded-circle " alt="profilepic">
                </div>
                <div class="d-flex flex-column pl-2">
                  <span class="black80 fontsize16 proximanova-semibold text-capitalize">{{sharevideo.videoUserFirstName}} {{sharevideo.videoUserLastName}}</span>
                  <span class="black80 fontsize12 proximanova text-capitalize">{{sharevideo.videoUserDesignation}}</span>
                </div>
              </div>
              <!-- <div>
                <video height="280" controls controlsList="nodownload" :poster="sharevideo.videoThumbnail" id="sharedvideo" >
                  <source :src="sharevideo.videoLink">
                </video>
              </div> -->
              <div class="videocardbody">
                <div class="overlay">
                  <div class="mt-3">
                    <img src="../assets/play_video.svg" class="playpostvideo" v-if="!videoplaying"  alt="play" @click="playsharingvideo">
                    <img src="../assets/Pausevideo.svg" class="pausebtn1 pausepostvideo" v-if="videoplaying" alt="pause" @click="playsharingvideo">
                  </div>
                </div>
                <div class="overlay1"></div>
                <video height="280" controlsList="nodownload" :poster="sharevideo.thumbnail" class="postedvideoItem" id="sharingvideo" >
                  <source :src="sharevideo.videoLink">
                </video>
              </div>
              <div class="sharedvideodetails d-flex flex-column p-3">
                <span class="black80 fontsize16 proximanova-semibold text-capitalize">{{sharevideo.videoTitle}}</span>
                <span class="black80 fontsize14 proximanova" v-if="sharevideo.videoType === 'POST'">{{sharevideo.videoDescription}}</span>
                <span class="black80 fontsize14 proximanova" v-else>{{sharevideo.userDetailsVo.videoDescription}}</span>
                <!-- <span class="black80 fontsize14 proximanova">{{sharevideo.userDetailsVo.videoDescription}}</span> -->
              </div>
          </div>
        </div>
        <div class="modal-footer sharemodalfooter">
          <button class="mr-3 btn button-cancel1 mouseoverbtn1 borderradius20" @click="close('NOTSUCCESS')">
            <span class="proximanova">Cancel</span>
          </button>
          <button class="mr-3 btn backgroundcolorblack borderradius20 mouseoverbtn2 white sign-up-button" type="submit" @click="shareVideo">
            <span class="button-create-font proximanova">Share</span>
          </button>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default {
  props : [
      'sharevideo'
  ],
  data() {
    return{
      Description : '',
      privacy : 'PUBLIC',
      videoplaying : false,
      profileId : null,
      videoId: null
    }
  },
  mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    console.log("sharedvideoob : ", this.sharevideo)
    if(this.sharevideo.operationType === 'edit') {
      this.Description = this.sharevideo.videoDescription
    }else{
      this.Description = ''
    }
    
  },
  methods: {
    playsharingvideo : function() {
      this.videoplaying = !this.videoplaying
      var video = document.getElementById('sharingvideo')
      if(!this.videoplaying){
        video.pause()
      }else{
        video.play()
      }
    },
    close(type) {
      this.$emit('close', type);
    },
    // sharing a video
    shareVideo : function() {
      var sfd = new FormData()
      var vm = this;
      if(this.sharevideo.videoType === 'SHARE'){        
        if(this.sharevideo.operationType === 'create'){
            this.videoId = null;
        }else if(this.sharevideo.operationType === 'edit'){
          this.videoId = this.sharevideo.id;
        }
        var obj = {
          id: this.videoId,
          profileId : this.profileId,
          oldVideoId : this.sharevideo.originalVideoId,
          videoOwnerProfileId :  this.sharevideo.videoUserId,
          // videoDescription : this.Description
        }
      }else{
        var obj = {
          id: this.videoId,
          profileId : this.profileId,
          oldVideoId : this.sharevideo.id,
          videoOwnerProfileId :  this.sharevideo.videoUserId,
          // videoDescription : this.Description
        }
      }
      console.log("obj : ", obj)
      console.log("privacy : ", this.privacy)
      var blob1 = new Blob([JSON.stringify(obj)], { type: "application/json" })
      var blob2 = new Blob([JSON.stringify(this.privacy)], { type: "application/json" })
      var blob3 = new Blob([JSON.stringify(this.Description)], { type: "application/json" })
      sfd.append("userVideoShare", blob1)
      sfd.append("visibility", blob2)
      sfd.append("videoDescription", blob3)
      httpuserprofile.post("/userprofile/shareVideo", sfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log("response : ", response)
        this.close('SUCCESS')
        vm.$toast.success("Video successfully shared.")
      }).catch((e) => {
        console.log(e)
      })
    }
  },
  beforeDestroy() {
    var video = document.getElementById('sharingvideo')
    if(video !== null && video !== undefined){
      video.pause()
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000 !important;
}
.modalhead{
  border-bottom: none;
}
.currentuserpropic {
  width: 50px;
  height: 50px;
  border: 2px solid #0078FF;
}
.videoownerpropic {
  width: 40px;
  height: 40px;
}
/* active state */
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 70%;
  margin-left: 11%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}

.label-create {
  color: rgba(31,31,31, 0.6);
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  margin-left: 11%;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -13px;
  font-size: 14px;
  /* color: #0078FF; */
}
.sharedcontent{
  border: 2px solid #DDDFE5;
  border-radius: 4px;
}
.sharemodalfooter{
  border-top: none;
}
.privacy{
  padding-left: 11%;
}
.bodymodal11{
  padding: 0 4% !important;
  height: 350px;
  overflow-y: auto;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    /* //padding: 20px; */
    background-attachment: scroll;
    overflow: hidden;
}
.videocardbody video {
    min-width: 100%;
    min-height: 100%;
    position: relative;
    z-index: 1;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    margin-top: -5px;
}
.playpostvideo {
  margin-left: 45%;
  margin-top: 13%;
  cursor: pointer;
}
.pausebtn1{
  display: none;
}
.overlay:hover .pausebtn1{
  display: block !important;
  margin-left: 45%;
  margin-top: 16%;
  cursor: pointer;
}
#sharedvideo{
  width: 100%;
}
button:active {
    outline: none;
    border: none;
}
.btn:focus{
  box-shadow: none;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
}
.button-cancel1:hover {
  border: 1px solid #1f1f1f;
  opacity: 1;
}
#profImage{
    width: 40px;
    height: 40px;
    line-height: 38px;
    border:1px solid #ced4da;
  }
  #profImage:hover{
    border: 1px solid #007AFF;
  }
</style>